import { LinkButtonWithIcon } from "@/components/Buttons/LinkButtonWithIcon"
import FormattedEmail from "@/components/FormattedEmail"
import { BuildingIcon } from "@/components/Icons"
import { EyeIcon, PlusIcon } from "@/components/Icons"
import { SheetField, SheetFieldGrid, SheetSection } from "@/components/Sections/SheetSection"
import { P3 } from "@/components/Typographies"
import { getClusterLinkSheet } from "@/domain/cluster/getClusterLinkSheet"
import { getCollaboratorLinkSheet } from "@/domain/collaborator/getCollaboratorLinkSheet"
import { getDisplayedName as getDisplayedCollaboratorName } from "@/domain/collaborator/getDisplayedName"
import type {
  ClusterJsonldReadCollectionSharedData,
  SharedDataJsonldReadCollectionSharedDataToManager,
} from "@/networking/api"
import { isNotNullNorUndefined } from "@/utils/ts-utils"
import { Button } from "@chakra-ui/react"
import { FormattedMessage, useIntl } from "react-intl"
import { useNavigate } from "react-router-dom"

type Props = {
  collaborator?: SharedDataJsonldReadCollectionSharedDataToManager
  cluster?: ClusterJsonldReadCollectionSharedData
  onDuplicate?: () => void
}

export const ReceiverSection = ({ cluster, collaborator, onDuplicate }: Props) => {
  const intl = useIntl()
  const navigateTo = useNavigate()

  return (
    <SheetSection
      title={intl.formatMessage({ id: "userSharedData.collaboratorTo.details" })}
      icon={BuildingIcon}
    >
      <SheetFieldGrid>
        {isNotNullNorUndefined(collaborator) && (
          <SheetField label={intl.formatMessage({ id: "userSharedData.localManager.name" })}>
            <P3 display="block">
              {getDisplayedCollaboratorName(collaborator)}
              <LinkButtonWithIcon
                display="inline-block"
                ml="2"
                icon={EyeIcon}
                onClick={() => navigateTo(getCollaboratorLinkSheet(collaborator))}
              />
            </P3>
            <P3 display="block">
              <FormattedEmail email={collaborator?.contactDetails?.[0]?.contactDetails?.email} />
            </P3>
          </SheetField>
        )}
        <SheetField label={intl.formatMessage({ id: "userSharedData.clusterTo.name" })}>
          <P3 display="block">
            {cluster?.name}{" "}
            <LinkButtonWithIcon
              display="inline-block"
              ml="2"
              icon={EyeIcon}
              onClick={() => navigateTo(getClusterLinkSheet(cluster))}
            />
          </P3>
        </SheetField>
      </SheetFieldGrid>
      {isNotNullNorUndefined(onDuplicate) && (
        <Button
          size="sm"
          display="flex"
          variant="outline"
          gap="2"
          mt="5"
          type="button"
          onClick={() => onDuplicate?.()}
        >
          <FormattedMessage id="userSharedData.duplicateRequest" />
          <PlusIcon boxSize={4} />
        </Button>
      )}
    </SheetSection>
  )
}
